import React from 'react';
import { Router } from 'react-router-dom';



const Routes = ({ component, history }) => {

  
  const Component = component;
  return (
    <Router history={history}>
      <Component>
        
      </Component>
    </Router>
  );
};

export default Routes;
